// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackSignUpParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackSignUp";

const useTrackSignUp = (parameters: TrackSignUpParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.util.getEventTrackerHook(ga.track.signUp, parameters, options);
};

export default useTrackSignUp;
